export const API_BASE_URL = '';

export const getSourceInstituitonsRoute = (educationProviderId) => {
  return '/src-institutions?eduProviderId=' + educationProviderId;
};

export const getCreditArrangementsRoute = (educationProviderId) => {
  return '/credit-arrangements?eduProviderId=' + educationProviderId;
};
